import React, { useState } from "react";
import Slider, { Settings } from "react-slick";

import TitleSection from "../title-section";
import CarouselControls from "../../atoms/carousel-controls/CarouselControls";
import JobCard from "../job-card/jobCard";

import { JobDetails } from "../../../interfaces/JobDetails";

// Styles //
import "slick-carousel/slick/slick.css";
import "./JobRecommendedCarousel.scss";

const MAIN_CLASS = "m-job-recommended-carousel";

interface JobRecommendedJobsCarouselProps {
    jobs: JobDetails[];
}

const SLIDES_TO_SCROLL = 1;

const JobRecommendedJobsCarousel = ({
    jobs,
}: JobRecommendedJobsCarouselProps) => {
    const [slider, setSlider] = useState<any>();

    const [sliderIndex, setSliderIndex] = useState(0);

    const CarouselGeneral: Settings  = {
        arrows: false,
        slidesToScroll: SLIDES_TO_SCROLL,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        variableWidth: true,
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        beforeChange: (_: number, next: number) => {
            setSliderIndex(next);
        },
        responsive: [
        {
            breakpoint: 1330,
            settings: {
                slidesToShow: 1,
                dots:true,
                slidesToScroll: 1
            }
        }
        ],
    };

    const totalItems = jobs?.length || 0;

    const slidesToShow = slider?.props?.slidesToShow?.length || 3;

    const totalDots = totalItems - slidesToShow + SLIDES_TO_SCROLL;

    const totalSlidesIndex = totalDots - 1;

    const isActiveBack = sliderIndex > 0;

    const isActiveNext = sliderIndex < totalSlidesIndex;

    const goToNext = () => {
        if (!isActiveNext) return;
        setSliderIndex(sliderIndex + 1);
        slider.slickNext();
    };

    const goToBack = () => {
        if (!isActiveBack) return;
        setSliderIndex(sliderIndex - 1);
        slider.slickPrev();
    };

    if (!jobs || !jobs.length) return null;

    return (
        <div className={MAIN_CLASS}>
            <div className={`${MAIN_CLASS}__wrapper`}>
                <div className={`${MAIN_CLASS}__title-container`}>
                    <TitleSection title="Te puede interesar" type="h3" />
                    {totalItems > 3 && (
                        <CarouselControls
                            disablePrevBtn={!isActiveBack}
                            disableNextBtn={!isActiveNext}
                            onClickNextBtn={goToNext}
                            onClickPrevBtn={goToBack}
                        />
                    )}
                </div>

                <div className={`${MAIN_CLASS}__slider ${ totalItems < 3 ?  `${MAIN_CLASS}__slider--left` : '' } `}>
                    <Slider
                        ref={(c) => {
                            setSlider(c);
                        }}
                        {...CarouselGeneral}
                    >
                        {jobs?.map((jobDetails) => {
                            return (
                                <div key={jobDetails.referenceNumber}>
                                    <JobCard
                                        key={jobDetails.referenceNumber}
                                        title={jobDetails.title}
                                        date={jobDetails?.date}
                                        company={jobDetails.company}
                                        city={jobDetails.city}
                                        referenceNumber={
                                            jobDetails.referenceNumber
                                        }
                                        url={jobDetails.url}
                                        salary={jobDetails.salary}
                                    />
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    );
};

export default JobRecommendedJobsCarousel;
